import { useState } from 'react';
import Icon from './Icon';

const examples = [
  'Make the remaining dinners cheaper',
  'Keep dinners under 25 minutes',
  'Use more of what is already home',
  'Give us simpler kid-friendly dinners',
];

export default function AiBar({ onCommand }: { onCommand: (text: string) => void }) {
  const [value, setValue] = useState('');
  const [open, setOpen] = useState(false);
  function submit(text = value) {
    const clean = text.trim();
    if (!clean) return;
    onCommand(clean); setValue(''); setOpen(false);
  }
  return <div className="ai-wrap">
    {open && <div className="ai-suggestions">{examples.map((x) => <button key={x} onClick={() => submit(x)}>{x}</button>)}</div>}
    <div className="ai-bar"><div className="ai-mark"><Icon name="spark" /></div><input value={value} onFocus={() => setOpen(true)} onChange={(e) => setValue(e.target.value)} onKeyDown={(e) => e.key === 'Enter' && submit()} placeholder="Tell the planner what you want from the remaining week…" /><button onClick={() => submit()} aria-label="Send"><Icon name="arrow" /></button></div>
  </div>;
}
